import { render, staticRenderFns } from "./ChartRenderer.vue?vue&type=template&id=8dd221b0&scoped=true"
import script from "./ChartRenderer.vue?vue&type=script&lang=ts"
export * from "./ChartRenderer.vue?vue&type=script&lang=ts"
import style0 from "./ChartRenderer.vue?vue&type=style&index=0&id=8dd221b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd221b0",
  null
  
)

export default component.exports